export const getPublicBaseUrl = () => {
  const envUrl = process.env.NEXT_PUBLIC_SITE_URL;
  if (envUrl && envUrl.trim().length > 0) {
    return envUrl;
  }

  return "https://banksfinders.com";
};
